// 查询余额明细
const ICBankRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `details/ICBank/index${i + 1}`,
  name: `details/ICBank/Index${i + 1}`,
  component: () => import(`@/views/shopping/details/ICBank/index${i + 1}.vue`)
}))
const HSBankRoutes = Array.from({ length:7 }, (_, i) => ({
  path: `details/HSBank/index${i + 1}`,
  name: `details/HSBank/Index${i + 1}`,
  component: () => import(`@/views/shopping/details/HSBank/index${i + 1}.vue`)
}))

import detailsIndex from '@/views/shopping/details/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'details/index',
        name: 'detailsIndex',
        component: detailsIndex
      },
    // 查询余额明细，开始
    ...ICBankRoutes,
    ...HSBankRoutes,

  ],
};
